import { AppSignature } from 'src/app/models/app-signature';
import { Board, SubjectModel } from 'src/app/models/master.model';
import { GradeModel } from '../../../models/master.model';
import { InstituteAcademicYear, InstituteGradeDivision } from '../../institute-academic-year/models/institute-academic-year';

export class ModuleModel extends AppSignature {
    name: string;
    parentSubjectID: string;
}
export class SubjectDTO {
    subject: SubjectModel = new SubjectModel();
    modules: Array<ModuleModel> = new Array<ModuleModel>();
}

export class subjectViewDTO {
    subject: SubjectModel = new SubjectModel();
    modules: Array<ModuleDTO> = new Array<ModuleDTO>();
}

export class ModuleDTO {
    module: ModuleModel = new ModuleModel();
    inUse: boolean;
}

export class InstituteGradeSubjectModel extends AppSignature {
    parentInstituteID: string;
    parentGradeID: string;
    parentBoardID: string;
    parentSubjectID: string;
    parentModuleID: string;
    subjectName: string;
    gradeName: string;
    sortOrder: number;
}

export class GradeSubjectDTO {
    subject: InstituteGradeSubjectModel = new InstituteGradeSubjectModel();
    inUse: boolean = false;
}

export class InstituteGradeSubjectDTO {
    subjects: Array<GradeSubjectDTO> = new Array<GradeSubjectDTO>();
    grade: GradeModel = new GradeModel();
    academicYear: InstituteAcademicYear = new InstituteAcademicYear();
}

export class InstituteDivisionSubjectDTO {
    division: InstituteGradeDivision = new InstituteGradeDivision();
    subjects: Array<InstituteGradeSubjectModel> = new Array<InstituteGradeSubjectModel>();
}

export class InstituteAcademicYearGradeSubjectPost {
    academicYear: InstituteAcademicYear = new InstituteAcademicYear();
    grade: GradeModel = new GradeModel();
    divisionSubjects: Array<InstituteDivisionSubjectDTO> = new Array<InstituteDivisionSubjectDTO>();
}

export class BoardGradeSubjectModel {
    board: Board = new Board();
    grade: GradeModel = new GradeModel();
    academicYear: InstituteAcademicYear = new InstituteAcademicYear();
    subject: InstituteGradeSubjectModel = new InstituteGradeSubjectModel();
}